<template>
  <custom-dialog
    :openDialog="isOpen"
    :widthDialog="'500px'"
    :classDialog="'dialog-doc-out-finish'"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('closed')"
  >
    <template #header>
      <h3 class="dialogTitle margin-left-10">
        Ký duyệt văn bản
      </h3>
    </template>

    <template #body>
      <div>
        <!--        <h3 class="dialogTitle">Ký duyệt văn bản</h3>-->
        <div class="has-border__bottom padding-bottom-10">
          <el-form label-position="top" ref="form" :model="form">
            <el-form-item label="Ý kiến/đề xuất">
              <el-input
                v-model="form.content"
                type="textarea"
                placeholder="_"
                maxlength="400"
                show-word-limit
                :autosize="{ minRows: 5, maxRows: 7 }"
              />
            </el-form-item>
          </el-form>
        </div>
      </div>
    </template>
    <template #footer>
      <div class="flex-row flex__between">
        <div class="flex-row flex__left">
          <em class="font-size__small">
            <span class="color__red">(*)</span> Xác nhận Ký duyệt văn bản</em
          >
        </div>
        <div class="flex-row flex__right form-button__action margin-top-10">
          <el-button
            type="success"
            size="mini"
            class="addDocs  color__white bg__blue btn-none__border"
            @click="banHanh"
            :disabled="isProcessing"
          >
            <i
              :class="[
                !isProcessing
                  ? 'fas fa-check-circle font-size__small'
                  : 'el-icon-loading'
              ]"
            ></i>
            &nbsp;Xác nhận
          </el-button>
        </div>
      </div>
    </template>
  </custom-dialog>
</template>
<script>
  import constants from "../../../constants";
  import errorMessageFilter from "../../../filters/errorMessageFilter";
  import categoryService from "../../../services/categoryService";
  import departmentService from "../../../services/departmentService";
  import outgoingDocService from "../../../services/outgoingDocService";
  import vbFlowService from "../../../services/vbFlowService";
  import vbStepService from "../../../services/vbStepService";
  import CustomDialog from "../../common/custom-dialog";
  import handleRequestErrorMixin from "../../handleRequestErrorMixin";
  import vbOutgoingProcessService from "../../../services/vbOutgoingProcessService";
  import {EventBus} from "../../../event-bus.js";

  export default {
    name: "DocOutKetThuc",
    mixins: [handleRequestErrorMixin],
    props: ["isOpen", "vbOutgoingProcessId", "docId"],
    components: {CustomDialog},

    computed: {
      parentRoute() {
        return this.$route.path.split("/")[3];
      },

      userDeptRole() {
        return this.$store.getters.userDeptRole;
      }
    },

    data() {
      return {
        isProcessing: false,
        form: {content: null},
        stepId: null,
        vbStep: null,
        vbOutgoingProcess: null,
        flowId: null,
        flow: null,
        publisher: null,
        vbOutgoingDoc: null,
        docTypeCode: null
      };
    },

    async created() {
      await this.loadVbOutgoingDoc();
      await this.loadPublisher();
      await this.initDocType();
      await this.loadVbOutgoingProcess();
      await this.loadVbStep();
      await this.loadFlow();
      this.initForm();
    },

    methods: {

      initDocType() {
        return (this.vbOutgoingDoc.docTypeCode
            ? Promise.resolve(this.vbOutgoingDoc.docTypeCode)
            : (this.vbOutgoingDoc.docTypeId
                ? categoryService
                  .findById(this.vbOutgoingDoc.docTypeId)
                  .then(response => response.data)
                : Promise.resolve(null)
            ).then(docType => (docType ? docType.categoryCode : null))
        ).then(docTypeCode => (this.docTypeCode = docTypeCode));
      },

      loadPublisher() {
        return departmentService
          .findById(this.vbOutgoingDoc.publisherId)
          .then(response => (this.publisher = response.data));
      },

      loadVbOutgoingDoc() {
        return outgoingDocService
          .findById(this.docId)
          .then(response => (this.vbOutgoingDoc = response.data));
      },

      loadFlow() {
        return vbFlowService
          .findById(this.flowId)
          .then(response => (this.flow = response.data));
      },

      loadVbOutgoingProcess() {
        return vbOutgoingProcessService
          .findById(this.vbOutgoingProcessId)
          .then(response => {
            this.vbOutgoingProcess = response.data;
            this.stepId = this.vbOutgoingProcess.stepId;
          });
      },

      /**
       * 2. Trong TH ký duyệt cuối cùng:
       2.1: luồng đồng trinh: content = <null>
       2.2.1: trong TH văn bản là loại tờ trình (đơn vị ban hành là cấp phòng/ban): content = "Đồng ý"
       2.2.2: còn lại: content = <null>
       */
      initForm() {
        let content;
        if (
          this.flow &&
          this.flow.flowType !== constants.FLOW_TYPE.DONG_TRINH &&
          this.publisher.path !== this.userDeptRole.deptPath &&
          this.publisher.path.startsWith(this.userDeptRole.deptPath) &&
          this.docTypeCode === constants.CATEGORY.CODE.DOC_TYPE.TO_TRINH
        ) {
          console.log("123123");
          content = errorMessageFilter({
            errorCode: "vbOutgoingDoc.defaultSignContent"
          });
        } else {
          content = "";
        }
        this.form.content = content;
      },

      loadVbStep() {
        return vbStepService.findById(this.stepId).then(response => {
          this.vbStep = response.data;
          this.flowId = this.vbStep.flowId;
        });
      },

      banHanh() {
        let submitForm = {
          outgoingProcessId: this.vbOutgoingProcessId,
          content: this.form.content,
          vbAttachmentDocx: (this.vbAttachmentDocx) ?  this.vbAttachmentDocx.id : null,
          vbAttachmentPdf: (this.vbAttachmentPdf) ?  this.vbAttachmentPdf.id : null,
        };

        this.isProcessing = true;
        vbOutgoingProcessService
          .ketThucLanhDaoEdit(submitForm, this.docId)
          .then(response => {
            this.$message({
              message: "Ký duyệt văn bản thành công",
              type: "success"
            });
            this.isProcessing = false;
            EventBus.$emit(this.parentRoute, {});
            this.$emit("success", {vbOutgoingProcess: response.data});
            EventBus.$emit('loadCounting', '');
          })
          .catch(error => {
            let makeError = JSON.parse(JSON.stringify(error))
            if(makeError.response && makeError.response.data && makeError.response.data.errors && makeError.response.data.errors.length > 0) {
              makeError.response.data.errors.forEach(errorData => {
                errorData.errorCode = errorData.params[0]
              })
            }
            this.commonHandleRequestError(makeError);
            this.isProcessing = false;
          });
      }
    }
  };
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/views/doc-out/components/DocOutKetThucLanhDao.vue